// Based on Material Design spec:
// Styles by https://github.com/RafeSacks
// https://material.io/design/components/sliders.html#spec
import { styled } from '@mui/material/styles'

const trackHeight = 2
const thumbHeight = 12

const MUI_RAIL_PREFIX = 'MuiRail'

export const muiRailClasses = {
  rail: `${MUI_RAIL_PREFIX}-rail`,
  railHotspot: `${MUI_RAIL_PREFIX}-railHotspot`,
}

export const StyledMuiRail = styled('div')(({ theme }) => ({
  [`& .${muiRailClasses.rail}`]: {
    backgroundColor: theme.palette.grey[400],
    width: '100%',
    height: trackHeight,
    position: 'absolute',
    pointerEvents: 'none',
  },
  [`& .${muiRailClasses.railHotspot}`]: {
    // backgroundColor: "green", // for debugging
    width: '100%',
    height: thumbHeight * 2, // Invisible hotspot same size as thumb
    top: thumbHeight * -1,
    position: 'absolute',
    cursor: 'pointer',
  },
}))

export const StyledMuiHandle = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  marginLeft: thumbHeight * -0.5,
  marginTop: thumbHeight * -0.5,
  width: thumbHeight,
  height: thumbHeight,
  border: 0,
  borderRadius: '50%', // circle
  // boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.2)",
  whiteSpace: 'nowrap', // for child display inline-block to work
  position: 'absolute',
  zIndex: 2,
  cursor: 'pointer',
}))

const MUI_TRACK_PREFIX = 'MuiTrack'

export const muiTrackClasses = {
  track: `${MUI_TRACK_PREFIX}-track`,
  trackHotspot: `${MUI_TRACK_PREFIX}-trackHotspot`,
}

export const StyledMuiTrack = styled('div')(({ theme }) => ({
  [`& .${muiTrackClasses.track}`]: {
    backgroundColor: theme.palette.secondary.main,
    height: trackHeight,
    position: 'absolute',
    zIndex: 1,
    pointerEvents: 'none',
  },
  [`& .${muiTrackClasses.trackHotspot}`]: {
    // backgroundColor: "grey", // for debugging
    height: thumbHeight, // Invisible hotspot same size as thumb
    top: thumbHeight * -0.5,
    position: 'absolute',
    cursor: 'pointer',
  },
}))

const MUI_TICK_PREFIX = 'MuiTick'

export const muiTickClasses = {
  tick: `${MUI_TICK_PREFIX}-tick`,
  label: `${MUI_TICK_PREFIX}-label`,
}

export const StyledMuiTick = styled('div')(({ theme }) => ({
  [`& .${muiTickClasses.tick}`]: {
    position: 'absolute',
    marginTop: 14,
    width: 1,
    height: 5,
    backgroundColor: theme.palette.grey[400],
  },
  [`& .${muiTickClasses.label}`]: {
    position: 'absolute',
    marginTop: 22,
    textAlign: 'center',
  },
}))
